import { useContext } from 'react';

import { QConfigContext } from './qconfig-provider';

function useQConfig() {
  const context = useContext(QConfigContext);

  if (!context) {
    throw new Error('useQConfig must be used within a QConfigProvider');
  }

  return context;
}

export { useQConfig };
